import { fluidResolvers } from '@1delta/data-sdk'

/**
 * Builds the multicall descriptor for Fluid fToken public data.
 *
 * Returns a single call to `LendingResolver.getFTokensEntireData()` — the
 * resolver hands back every fToken on the chain in one shot. No per-fToken
 * enumeration needed.
 *
 * Resolver address is constant across chains but sourced via the SDK so
 * future chain-specific deployments can diverge without code changes.
 */
export const buildFluidFTokensCall = (chainId: string) => {
  const resolvers = fluidResolvers()?.[chainId]
  if (!resolvers) return []

  return [
    {
      address: resolvers.lendingResolver,
      name: 'getFTokensEntireData',
      params: [],
    },
  ]
}
